import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const UserDeleteDialog = ({ open, onClose, onDelete, username }) => {
  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
  };

  const primaryButtonSx = {
    backgroundColor: "#d32f2f",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#b71c1c",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: dialogPaperSx }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "1.3rem",
          pt: 3,
          pb: 1,
          color: "#1f1f1f",
        }}
      >
        Deactivate User
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <WarningAmberIcon
            sx={{ fontSize: 40, color: "#f57c00" }}
          />
        </Box>

        <Typography
          sx={{
            color: "#444",
            fontSize: "0.95rem",
          }}
        >
          Are you sure you want to deactivate
        </Typography>

        <Typography
          sx={{
            fontWeight: 700,
            mt: 0.5,
            color: "#223142",
          }}
        >
          {username}
        </Typography>

        <Typography
          sx={{
            mt: 1,
            color: "#777",
            fontSize: "0.85rem",
          }}
        >
          The user will no longer be able to log in.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1.5,
          justifyContent: "center",
          gap: 1.25,
        }}
      >
        <Button onClick={onClose} variant="outlined" sx={secondaryButtonSx}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onDelete}
          sx={primaryButtonSx}
        >
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDeleteDialog;